import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { OpenInNew } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

import { getProjectMainData } from "slices/project_work";
import { getClickedTableRow } from "slices/ribbon";

import styles from "./ObjectEstimateReasonCell.module.css";

export const ObjectEstimateReasonCell = ({ rowObj, clmName, clmObj }) => {
	const projectMainData = useSelector(getProjectMainData);
	const value = rowObj[clmName];
	const modelName = rowObj.model_name;
	const isMultiRow = rowObj.rowHeightMultiply && rowObj.rowHeightMultiply > 1;
	const isLsr = modelName === "LocalEstimate";
	const projectEstimateId = rowObj.project_estimate_id;
	const clickedTableRow = useSelector(getClickedTableRow);
	const showLink = clickedTableRow?.id === rowObj.id && projectEstimateId && isLsr;
	const path = `/project/${projectMainData.id}/lsr/${projectEstimateId}/`;
	const style = {
		textAlign: clmObj.cellHorAlign,
		width: clmObj.width,
		maxWidth: clmObj.width,
		minWidth: clmObj.minWidth,
	};

	return (
		<td key={`cell-${clmName}-${rowObj.id}`} className="TableCell" clm={clmName} treecell="false" style={style} title={value}>
			<div className={styles.container}>
				<Box
					component={showLink ? RouterLink : undefined}
					to={path}
					className={styles.value}
					target="_blank"
					rel="noopener noreferrer"
					style={{
						whiteSpace: isMultiRow ? "normal" : "nowrap",
						textDecorationLine: showLink ? "underline" : "none",
					}}
				>
					{value}
				</Box>
				{showLink && (
					<IconButton
						component={RouterLink}
						to={path}
						target="_blank"
						rel="noopener noreferrer"
						title="Открыть в новой вкладке"
						sx={{ padding: "2px" }}
					>
						<OpenInNew sx={{ fontSize: "13px" }} />
					</IconButton>
				)}
			</div>
		</td>
	);
};
